import { safeGet, safeSet } from '../utils/browserSafe';
import baseURL from '../url';

export function getCachedGeo() {
    try {
        const raw = safeGet('ky13_geo_info');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.savedAt) return null;
        const age = Date.now() - parsed.savedAt;
        if (age > 12 * 60 * 60 * 1000) return null;
        return parsed;
    } catch (e) {
        return null;
    }
}

export async function fetchGeoInfo() {
    const cached = getCachedGeo();
    if (cached) return cached;

    try {
        const res = await fetch(`${baseURL}/geoCountry.php`, { cache: 'no-store' });
        const data = await res.json();
        const info = {
            isCuba: Boolean(data?.isCuba),
            countryCode: data?.countryCode || null,
            currencyMode: data?.currencyMode || (data?.isCuba ? 'MN' : 'USD'),
            currencySymbol: data?.currencySymbol || '$',
            savedAt: Date.now()
        };
        safeSet('ky13_geo_info', JSON.stringify(info));
        if (typeof window !== 'undefined') {
            try { window.dispatchEvent(new CustomEvent('ky13GeoUpdated', { detail: info })); }
            catch(e) { const ev = document.createEvent('CustomEvent'); ev.initCustomEvent('ky13GeoUpdated', false, false, info); window.dispatchEvent(ev); }
        }
        return info;
    } catch (e) {
        const fallback = {
            isCuba: false,
            countryCode: null,
            currencyMode: 'USD',
            currencySymbol: '$',
            savedAt: Date.now()
        };
        return fallback;
    }
}

export function getGeoCountryParam() {
    const cached = getCachedGeo();
    return cached?.countryCode ? `?country=${encodeURIComponent(cached.countryCode)}` : '';
}

export function getProductDisplayPrice(product, geoInfo = null) {
    if (!product) return 0;
    const isCuba = geoInfo ? Boolean(geoInfo.isCuba) : (product.precioModo === 'MN');
    const mn = Number(product.precioMn ?? product.precio ?? 0);
    const usd = Number(product.precioUsd ?? 0);
    if (isCuba) return Number((mn * 1.02).toFixed(2));
    return Number((usd * 1.02).toFixed(2));
}

export function filterProductByVisibility(product, geoInfo = null) {
    const visibility = product?.visibilidadPais || 'ambos';
    const isCuba = geoInfo ? Boolean(geoInfo.isCuba) : false;
    if (isCuba && visibility === 'fuera_cuba') return false;
    return true;
}

export function productWithDisplayPrice(product, geoInfo = null) {
    if (!product) return product;
    const isCuba = geoInfo ? Boolean(geoInfo.isCuba) : (product.precioModo === 'MN');
    const prevMn = Number(product.precioAnterior || 0);
    const mn = Number(product.precioMn || 0);
    const usd = Number(product.precioUsd || 0);
    const ratio = (mn > 0 && usd > 0) ? (mn / usd) : 1;
    const precioAnteriorDisplay = prevMn > 0
        ? Number((isCuba ? prevMn * 1.02 : ((ratio > 0 ? prevMn / ratio : prevMn) * 1.02)).toFixed(2))
        : product.precioAnterior;
    return {
        ...product,
        precioOriginalSistema: product.precioOriginalSistema ?? product.precio,
        precio: getProductDisplayPrice(product, geoInfo),
        precioAnteriorDisplay,
        precioModo: geoInfo?.currencyMode || product.precioModo || (geoInfo?.isCuba ? 'MN' : 'USD')
    };
}
